import { render, staticRenderFns } from "./debtorDebts.vue?vue&type=template&id=0d967e0e&"
import script from "./debtorDebts.vue?vue&type=script&lang=js&"
export * from "./debtorDebts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports